module.exports = ".search-radio-group {\r\n  display: -webkit-inline-box;\r\n  display: -ms-inline-flexbox;\r\n  display: inline-flex;\r\n  -webkit-box-orient: vertical;\r\n  -webkit-box-direction: normal;\r\n      -ms-flex-direction: column;\r\n          flex-direction: column;\r\n}\r\n\r\n.search-radio-button {\r\n  margin: 5px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/ui/search-edition-form/search-edition-form.component.css
// module id = ./src/app/components/ui/search-edition-form/search-edition-form.component.css
// module chunks = main